import { render, staticRenderFns } from "./EConteudoAulaInfantil.vue?vue&type=template&id=5ff3fa86&scoped=true"
import script from "./EConteudoAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EConteudoAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./EConteudoAulaInfantil.vue?vue&type=style&index=0&id=5ff3fa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3fa86",
  null
  
)

export default component.exports